import toast from "react-hot-toast";
import { useUpgradeSubscription } from "../../../../../queries/pricing";
import { useState } from "react";
import { useUserInfo } from "../../../../../context/user";
import { Check } from "@mui/icons-material";

const UpgradePlanModal = ({
  onClose,
  price_id,
  plan,
  paymentMethod_id,
  agency,
}) => {
  const { mutateAsync: upgradeSubscription } = useUpgradeSubscription();
  const [loading, setLoading] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const saveActiveLocation = useUserInfo()[5];

  const handleConfirmClick = async () => {
    setLoading(true);
    let subscription, error;
    try {
      subscription = await upgradeSubscription({
        agency_id: userActiveLocation?.agency_id,
        price_id,
        plan_id: plan?._id,
        account_id: userActiveLocation?._id,
        paymentMethod_id,
        customer_id: userActiveLocation?.customer_id,
        subscription_id: userActiveLocation?.subscription_id,
        subscription_type: "upgrade",
      });
    } catch (err) {
      error = err?.response?.data;
    }
    if (subscription?.data) {
      saveActiveLocation(subscription.data);
      toast.success("Subscription updated successfully!");
    } else {
      toast.error(error?.message || "Failed to create subscription");
    }
    setLoading(false);
    onClose();
  };
  return (
    <div>
      {/* Title */}
      <h2 className="text-lg font-medium text-center mb-6">
        Confirm Your Upgrade
      </h2>

      {/* Features */}
      <div className="space-y-5">
        <div className="flex items-start gap-3">
          <Check className="text-blue-500 w-5 h-5" />
          <div>
            <p className="font-medium">
              {agency?.upgrade_benefits?.[0] || "More output"}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Check className="text-blue-500 w-5 h-5" />
          <div>
            <p className="font-medium">
              {agency?.upgrade_benefits?.[1] || "Faster results"}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Check className="text-blue-500 w-5 h-5" />
          <div>
            <p className="font-medium">
              {agency?.upgrade_benefits?.[2] || "No data lost"}
            </p>
          </div>
        </div>
      </div>

      {/* Upgrade Button */}
      <button
        onClick={handleConfirmClick}
        disabled={loading}
        className="mt-8 w-full bg-primary text-primary-foreground py-3 rounded-lg hover:bg-primary/90 transition"
      >
        {loading ? "wait..." : "Yes, Upgrade My Plan"}
      </button>
    </div>
  );
};

export default UpgradePlanModal;
